import React from 'react'
import './featured-tracks-carosel.css';
import TrackThumbnail from '../track-thumbnail/track-thumbnail';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper/modules';
// import { useMediaQuery, useTheme } from '@mui/material';

// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

const FeaturedTracksCarosel = ({trackList}) => {
	
	
	// const theme = useTheme();
	// // Determine if it's a small screen
    // const isXs = useMediaQuery(theme.breakpoints.down('sm'));  // <600px
    // const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600px - 900px
    // const isMd = useMediaQuery(theme.breakpoints.between('md', 'lg')); // 900px - 1200px
    // const isLg = useMediaQuery(theme.breakpoints.up('lg'));  // >1200px

    // // Dynamically calculate slides per view based on screen size
    // let slidesPerView;
    // if (isXs) slidesPerView = 1;
    // else if (isSm) slidesPerView = 2;
    // else if (isMd) slidesPerView = 3;
    // else if (isLg) slidesPerView = 4;
    // else slidesPerView = 3; // Default fallback
	

	return (
		<div className='tracks-features-carosel'>
			{/* <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={10}
                slidesPerView={slidesPerView} // Adjust this to display more elements
                loop={true}
                navigation={true} // Enables navigation buttons
                pagination={{ clickable: true }} // Enables pagination dots
            > */}
  				{/* <div className="swiper-wrapper"> */}
					{trackList.map((t) => {
						return (
							// <SwiperSlide key={t.id}>
								<TrackThumbnail key={t.id} track={t} playlist={trackList} artist={t.artist} size='sm' />
							// </SwiperSlide>
						)
					})}
				{/* </div> */}
				{/* <div className="swiper-button-prev"></div>
  				<div className="swiper-button-next"></div> */}
			{/* </Swiper> */}
		</div>
	)
}

export default FeaturedTracksCarosel;